import { render, staticRenderFns } from "./SettingProfileName.vue?vue&type=template&id=386f6a18&scoped=true&"
import script from "./SettingProfileName.vue?vue&type=script&lang=js&"
export * from "./SettingProfileName.vue?vue&type=script&lang=js&"
import style0 from "./SettingProfileName.vue?vue&type=style&index=0&id=386f6a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f6a18",
  null
  
)

export default component.exports